export const errorsAuth: {
    [index: string]: {
        title: string
        description?: string
    }
} = {
    '0001': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique os dados e tente novamente.'
    },
    '0002': {
        title: 'Algo deu errado.',
        description: 'Tente novamente em alguns minutos.'
    },
    '0003': {
        title: 'Código de confirmação expirado.',
        description: 'Solicite uma nova senha.'
    },
    '0004': {
        title: 'O tempo de resposta da solicitação foi excedido.'
    },
    '0005': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique os dados e tente novamente.'
    },
    '0006': {
        title: 'Preenchimento incorreto.',
        description: 'Verifique o e-mail e tente novamente.'
    },
    '0007': {
        title: 'Código inválido.',
        description: 'Verifique os dados e tente novamente.'
    },
    '0009': {
        title: 'Usuário não informado.',
        description: 'Usuário não informado.'
    },
    '0010': {
        title: 'Guid do usuário no formato inválido.',
        description: 'Guid do usuário no formato inválido.'
    },
    '0011': {
        title: 'Nome do usuário inválido.',
        description: 'Nome do usuário inválido.'
    },
    '0012': {
        title: 'O usuário informado já existe.',
        description: 'O usuário informado já existe.'
    },
    '0013': {
        title: 'Usuário bloqueado.',
        description: 'Usuário bloqueado de efetuar o login.'
    },
    '0014': {
        title: 'Captcha inválido.',
        description: 'Verifique os dados e tente novamente.'
    },
    '0019': {
        title: 'Algo deu errado.',
        description: 'Tente novamente em alguns minutos.'
    },
    '0020': {
        title: 'Captcha expirado ou já utilizado.',
        description: 'Tente novamente em alguns minutos.'
    }
}
